var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessageAgain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8079 4.49023H5.89128C5.10887 4.49023 4.47461 5.1245 4.47461 5.9069V15.8236C4.47461 16.606 5.10887 17.2402 5.89128 17.2402H15.8079C16.5903 17.2402 17.2246 16.606 17.2246 15.8236V5.9069C17.2246 5.1245 16.5903 4.49023 15.8079 4.49023Z",
    stroke: "#616E85",
    strokeWidth: 1.23958,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43359 13.3184L12.2669 8.41088",
    stroke: "#616E85",
    strokeWidth: 1.23958,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageAgain);
export default __webpack_public_path__ + "static/media/SendMessageAgain.cc5809d7abc5d1b1f6e68ecbf01bd266.svg";
export { ForwardRef as ReactComponent };